import React, { Fragment } from 'react';

import { useBrowserIdle } from '@crehana/react-hooks';

const IdleComponent: React.FC = ({ children }) => {
  const isIdle = useBrowserIdle();

  if (!isIdle) {
    return null;
  }

  return <Fragment>{children}</Fragment>;
};

export default IdleComponent;
